export type LogLevel = "trace" | "debug" | "info" | "warn" | "error";

export interface Logger {
  trace(message: string, meta?: unknown): void;
  debug(message: string, meta?: unknown): void;
  info(message: string, meta?: unknown): void;
  warn(message: string, meta?: unknown): void;
  error(message: string, meta?: unknown): void;
}

export class NoopLogger implements Logger {
  trace(): void {
    return;
  }
  debug(): void {
    return;
  }
  info(): void {
    return;
  }
  warn(): void {
    return;
  }
  error(): void {
    return;
  }
}

export function createConsoleLogger(prefix = "Adonis"): Logger {
  const fmt = (lvl: LogLevel, msg: string) =>
    `[${prefix}] ${lvl.toUpperCase()}: ${msg}`;
  return {
    trace: (m, meta) =>
      meta
        ? console.debug(fmt("trace", m), meta)
        : console.debug(fmt("trace", m)),
    debug: (m, meta) =>
      meta
        ? console.debug(fmt("debug", m), meta)
        : console.debug(fmt("debug", m)),
    info: (m, meta) =>
      meta ? console.info(fmt("info", m), meta) : console.info(fmt("info", m)),
    warn: (m, meta) =>
      meta ? console.warn(fmt("warn", m), meta) : console.warn(fmt("warn", m)),
    error: (m, meta) =>
      meta
        ? console.error(fmt("error", m), meta)
        : console.error(fmt("error", m)),
  };
}
